import * as React from 'react';

export const SlashRoot = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="" style={{ width: '300px' }}>
      <div className="overflow-y-auto border-b border-gray-200" style={{ maxHeight: '266px' }}>
        {children}
      </div>
      <div className="flex py-8 px-12 justify-end h-34">{/* <button>Explore</button> */}</div>
    </div>
  );
};
